import { Link } from 'react-router-dom'
import './Button.css'

export default function Button({
  children,
  variant = 'primary',
  onClick,
  type = 'button',
  style = {},
  small,
  href,
  to,
  disabled = false,
}) {
  const className = `pcbtn pcbtn--${variant}${small ? ' pcbtn--sm' : ''}`

  if (disabled) {
    return (
      <button type="button" className={`${className} pcbtn--disabled`} style={style} disabled>
        {children}
      </button>
    )
  }

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={className} style={style}>
        {children}
      </Link>
    )
  }

  if (href) {
    return (
      <a href={href} onClick={onClick} className={className} style={style}>
        {children}
      </a>
    )
  }

  return (
    <button type={type} onClick={onClick} className={className} style={style}>
      {children}
    </button>
  )
}
